export default __webpack_public_path__ + "static/media/Background 5_00044.39312ee3.png";